import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useDispatch } from 'react-redux';
import { setLoading } from '../../redux/Slice/loaderSlice';
import axios from 'axios';
import { authHeader } from '../../Api/authHeader';

const API_URL = process.env.REACT_APP_API_URL;

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export default function CloudUpload({setFile, file, placeholder}) {

    const dispatch = useDispatch()

  function getImageNameWithoutExtension(url) {
    const parts = url.split('/');
    const imageNameWithExtension = parts[parts.length - 1];
    const [imageName, extension] = imageNameWithExtension.split('.');
    return imageName;
  }
  

  const handleFileChange = async (event) => {
    // console.log(file);
    dispatch(setLoading(true));
    if(file === null){
      try {
        const formData = new FormData();
        formData.append('image', event.target.files[0]);
        const response = await axios.post(API_URL + '/api/images/uploadImage', formData, { headers: authHeader() });
        setFile(response.data.imageUrl);
        // setFile(URL.createObjectURL(event.target.files[0]));
        dispatch(setLoading(false))

      } catch (error) {
        dispatch(setLoading(false))
      } finally {
        dispatch(setLoading(false))
      }
    }
    else{
      try {
        const imageName = getImageNameWithoutExtension(file);
        const formData = new FormData();
        formData.append('image', event.target.files[0]);
        // const response = await axios.post(API_URL + `/upload/${imageName}`, formData, { headers: authHeader() });
        // setFile(response.data.url);
        // setFile(URL.createObjectURL(event.target.files[0]));
        const response = await axios.post(API_URL + '/api/images/uploadImage', formData, { headers: authHeader() });
        setFile(response.data.imageUrl);
        dispatch(setLoading(false))

      } catch (error) {
        dispatch(setLoading(false))
      } finally {
        dispatch(setLoading(false))
      }
    }
  };

  return (
    <Button sx={{p: 10,}} size='large' component="label" variant="outlined" startIcon={!file && <CloudUploadIcon />}>
      {!file ? (placeholder ? placeholder : 'Upload Proof') :
      <img src={file} width={100} alt='img'></img>}
      <VisuallyHiddenInput onChange={handleFileChange} type="file" />
    </Button>
  );
}